import React, { Component } from 'react';
import ImageBlock from './ImageBlock';
import './report.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

class NewImageUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadButtonText: '+',
      errorText: '',
    };
  }

  setErrorText = error => {
    this.setState({ errorText: error });
  };

  clickInput = index => {
    const inputToClick = document.getElementById(`img${index}`);
    inputToClick.click();
  };

  uploadButton = () => {
    let full = true;
    this.props.stateImages.forEach(image => {
      if (!image) {
        full = false;
      }
    });
    if (!full) {
      return (
        <button
          type="button"
          className="upload-button"
          onClick={() => {
            for (let i = 0; i < this.props.stateImages.length; i++) {
              if (!this.props.stateImages[i]) {
                this.clickInput(i);
                break;
              }
            }
          }}>
          {/* {this.state.uploadButtonText} */}
          <FontAwesomeIcon icon={faPlus} size="2x" />
        </button>
      );
    }
  };

  limitSize = fileSize => fileSize <= 10000000;

  render() {
    const { stateImages, saveFileToState, removeImageFromState } = this.props;

    return (
      <div className="spacing">
        <h4>Upload Image</h4>
        {/* <p style={{ textAlign: 'left', marginTop: '3rem' }}>
          If you have any images, please upload them here (up to 5).
        </p> */}

        <p className="error-text">{this.props.error || this.state.errorText}</p>

        <div className="image-list">
          {[...Array(5)].map((x, i) => (
            <ImageBlock
              key={x}
              index={i}
              stateImages={stateImages}
              removeImageFromState={removeImageFromState}
              saveFileToState={saveFileToState}
              limitSize={this.limitSize}
              setErrorText={this.setErrorText}
            />
          ))}
        </div>
        {this.uploadButton()}
      </div>
    );
  }
}

export default NewImageUploader;



// WEBPACK FOOTER //
// ./src/components/Report/NewImageUploader.js